export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-8">
              The Largest Spreadsheet Resource Hub
            </h2>

            <div className="grid grid-cols-3 gap-6">
              <div className="border-r border-background-200/70 pr-6">
                <p className="text-4xl md:text-5xl font-heading font-bold text-primary-500 mb-2">500+</p>
                <p className="text-sm text-foreground-600">Verified Seller Links</p>
              </div>
              <div className="border-r border-background-200/70 pr-6">
                <p className="text-4xl md:text-5xl font-heading font-bold text-accent-500 mb-2">14</p>
                <p className="text-sm text-foreground-600">Product Categories</p>
              </div>
              <div className="pr-6">
                <p className="text-4xl md:text-5xl font-heading font-bold text-secondary-600 mb-2">100%</p>
                <p className="text-sm text-foreground-600">Free Access</p>
              </div>
            </div>

            <p className="mt-8 text-sm text-foreground-600 leading-relaxed max-w-lg">
              Our directory connects you to the most reliable CSSBuy spreadsheet resources across every major product category. From sneakers to accessories, every link is manually verified and organized for effortless browsing.
            </p>
          </div>

          <div className="flex-1 w-full">
            <div className="relative h-72 md:h-80 rounded-2xl overflow-hidden bg-gradient-to-br from-accent-100 via-accent-50 to-secondary-100">
              <div className="absolute top-8 left-8 w-24 h-24 rounded-2xl bg-accent-200/50"></div>
              <div className="absolute top-16 right-10 w-32 h-32 rounded-full bg-primary-100/60"></div>
              <div className="absolute bottom-6 left-20 w-28 h-28 rounded-2xl bg-secondary-200/50"></div>
              <div className="absolute bottom-10 right-16 w-20 h-20 rounded-full bg-accent-300/40"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
                <div className="w-16 h-16 rounded-2xl bg-background-50/80 backdrop-blur-sm flex items-center justify-center mx-auto mb-3">
                  <i className="ri-stack-line text-2xl text-primary-500"></i>
                </div>
                <p className="text-sm font-semibold text-foreground-800">Free & Curated</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}